import React from 'react';
import { motion } from 'framer-motion';
const characters = [{
  emoji: '🎃',
  name: 'Don Zapallo',
  color: 'from-orange-400 to-yellow-400',
  border: 'border-orange-300',
  bg: 'bg-orange-50',
  accent: 'text-orange-600',
  description: 'El sabio de la huerta. Don Zapallo comparte sus mejores secretos para que las verduras sean irresistibles y llenas de sabor.',
  image: 'https://cdn.magicpatterns.com/uploads/93JeFjKLiyrTJQnvwdbNo5/don_zapalloheylloyd-image-1771980052877.png'
}, {
  emoji: '🥦',
  name: 'Zulemita',
  color: 'from-emerald-400 to-green-500',
  border: 'border-emerald-300',
  bg: 'bg-emerald-50',
  accent: 'text-emerald-600',
  description: 'La más traviesa y divertida. Zulemita tiene un tip especial en cada receta para que los nenes quieran repetir.',
  image: 'https://cdn.magicpatterns.com/uploads/4oJiZDBVB9qmcXhmkTuChC/zulemitaheylloyd-image-1771979130889.png'
}, {
  emoji: '🥕',
  name: 'Dorotea',
  color: 'from-violet-400 to-pink-400',
  border: 'border-violet-300',
  bg: 'bg-violet-50',
  accent: 'text-violet-600',
  description: 'La experta en actividades. Dorotea propone juegos y manualidades para hacer en familia mientras se cocina.',
  image: 'https://cdn.magicpatterns.com/uploads/vxS2Qd9Zwawr6tWD5FU76U/doroteamejoradaheylloyd-image-1771978417679.png'
}];
export function CharactersSection() {
  return <section className="pt-12 pb-12 bg-[#FEE9D0] relative overflow-hidden" data-id="element-17">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-80 h-80 bg-orange-200 rounded-full blur-3xl opacity-40 -z-10" data-id="element-18" />
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-violet-200 rounded-full blur-3xl opacity-30 -z-10" data-id="element-19" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-20">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14" data-id="element-21">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-4xl md:text-5xl font-extrabold leading-tight mb-4" data-id="element-22">
            <span className="bg-gradient-to-r from-orange-500 via-violet-600 to-emerald-500 bg-clip-text text-transparent" data-id="element-23">
              ¡Conocé a nuestros amigos!
            </span>
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} className="text-lg text-gray-600 font-medium" data-id="element-24">
            Don Zapallo, Zulemita y Dorotea los acompañarán en cada receta con
            recomendaciones, tips y actividades para hacer en familia 🌟
          </motion.p>
        </div>

        {/* Character cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-4xl mx-auto" data-id="element-25">
          {characters.map((char, i) => <motion.div key={char.name} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className={`${char.bg} rounded-3xl border-4 ${char.border} shadow-lg p-8 flex flex-col items-center text-center`} data-id="element-26">
              {/* Avatar */}
              {char.image ? <div className={`w-full rounded-2xl border-4 ${char.border} shadow-md mb-5 overflow-hidden`} style={{
            height: '280px'
          }} data-id="element-27">
                  <img src={char.image} alt={char.name} className="w-full h-full object-cover object-center" data-id="element-28" />
                </div> : <div className={`w-24 h-24 rounded-full bg-gradient-to-br ${char.color} flex items-center justify-center text-5xl shadow-md mb-5`} data-id="element-29">
                  {char.emoji}
                </div>}

              <h3 className={`text-2xl font-extrabold mb-3 ${char.accent}`} data-id="element-30">
                {char.name}
              </h3>
              <p className="text-gray-600 text-base leading-relaxed font-medium" data-id="element-31">
                {char.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}